import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/yellow_Title_Tip.png'


const _withScopeId = n => (_pushScopeId("data-v-64e55728"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "risk-text" }
const _hoisted_4 = {
  key: 0,
  class: "risk-modal-overlay"
}
const _hoisted_5 = { class: "risk-modal" }
const _hoisted_6 = { class: "risk-modal-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "risk-modal-icon",
  alt: ""
}, null, -1))
const _hoisted_8 = { class: "risk-modal-body" }
const _hoisted_9 = { class: "risk-modal-footer" }
const _hoisted_10 = { class: "strategy-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: "strategy-page",
    style: _normalizeStyle({ background: _ctx.isDark ? '#000000' : '#e6e9ef' })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["strategy-tabs", { light: !_ctx.isDark }])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["tab-item tab-subscription", { active: _ctx.isSubscriptionActive }]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goSubscription && _ctx.goSubscription(...args)))
      }, _toDisplayString(_ctx.tran('我的订阅')), 3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.category,
          class: _normalizeClass(["tab-item", { active: _ctx.activeCategoryName === String(item.category) }]),
          onClick: ($event: any) => (_ctx.goCategory(String(item.category)))
        }, _toDisplayString(item.name), 11, _hoisted_1))
      }), 128)),
      _createElementVNode("div", {
        class: "place",
        style: _normalizeStyle({ background: _ctx.isDark ? '#1A1D2F' : '#F2F5FB' })
      }, [
        _createElementVNode("div", {
          class: "risk",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRiskModal = true)),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isRiskHover = true)),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isRiskHover = false))
        }, [
          _createElementVNode("img", {
            src: _ctx.isRiskHover ? require('@/assets/yellow_Title_Tip_Hover.png') : (_ctx.isDark ? require('@/assets/Tip_dark.png') : require('@/assets/Tip_light.png')),
            class: "risk-icon",
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.tran('风险提示')), 1)
        ], 32)
      ], 4)
    ], 2),
    (_ctx.showRiskModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.tran('风险提示')), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.tran('以上资讯、数据不构成销售或建议任何投资、交易策略或金融产品的要约或招揽。投资未必一定能够赚取利润，反而可能会招致损失。据此操作，一切损失与万泰金融控股有限公司无关。')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "risk-modal-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showRiskModal = false))
              }, _toDisplayString(_ctx.tran('知道了')), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_view)
    ])
  ], 4))
}